import "Enum.js";

/** @namespace GIS */
NS("GIS");

/**
 * @class
 * @enum {number}
 * @extends Enum
 */
GIS.Geometry = Static(Enum, /** @lends GIS.Geometry */ {
    Point: 1,
    LineString: 2,
    Polygon: 3,
    MultiPoint: 4,
    MultiLineString: 5,
    MultiPolygon: 6,
    GeometryCollection: 7,
    /**
     * @param {number} value
     * @returns {string|undefined}
     */
    title(value) {
        switch (_.parseInt(value)) {
            case this.Point:
                return "Точка";
            case this.LineString:
                return "Линия";
            case this.Polygon:
                return "Полигон";
            case this.MultiPoint:
                return "Группа точек";
            case this.MultiLineString:
                return "Группа линий";
            case this.MultiPolygon:
                return "Группа полигонов";
            case this.GeometryCollection:
                return "Группа геометрий";
            default:
                return this.ParentCall();
        }
    },
    /**
     * @param {number} value
     * @returns {boolean} Returns true is geometry is an multi geometry like MultiPoint, MultiLineString
     */
    isMulti(value) {
        return _.includes([this.MultiPoint, this.MultiLineString, this.MultiPolygon], value);
    },
    /**
     * @param {number} value
     * @returns {boolean} Returns true is geometry is an single type geometry like Point
     */
    isSingle(value) {
        return _.includes([this.Point, this.LineString, this.Polygon], value);
    },
    /**
     * @param {number} value
     * @returns {boolean} Returns true if geometry is an simple geometry, not GeometryCollection
     */
    isSimple(value) {
        return _.includes([this.Point, this.LineString, this.Polygon, this.MultiPoint, this.MultiLineString, this.MultiPolygon], value);
    },
    /**
     * @param {number} value
     * @returns {string} Returns simplified geometry name
     */
    simpleName(value) {
        switch (_.parseInt(value)) {
            case this.Point:
            case this.MultiPoint:
                return "point";
            case this.LineString:
            case this.MultiLineString:
                return "line";
            case this.Polygon:
            case this.MultiPolygon:
                return "polygon";
            case this.GeometryCollection:
                return "collection";
            default:
                return "";
        }
    },
    /**
     * @param {number} value
     * @returns {number}
     */
    simpleId(value)
    {
        switch (_.parseInt(value)) {
            case this.Point:
            case this.MultiPoint:
                return this.Point;
            case this.LineString:
            case this.MultiLineString:
                return this.LineString;
            case this.Polygon:
            case this.MultiPolygon:
                return this.Polygon;
            case this.GeometryCollection:
                return this.GeometryCollection;
            default:
                return;
        }
    },
    /**
     * @param {number} d
     * @param {number} [m=0]
     * @param {number} [s=0]
     * @returns {number}
     */
    dmsToDeg(d, m = 0, s = 0) {
        return Number(((Math.abs(d) + (m / 60) + (s / 3600)) * (d < 0 ? -1 : 1)).toFixed(6));
    },
    /**
     * Converts string with degrees/minutes/seconds into decimal degrees.
     * @param {string} dmsString
     * @returns {*}
     */
    dmsStringToDeg(dmsString) {
        var deg, sw, match, d, m, s;

        sw = /[swзю\-]/i.test(dmsString);
        dmsString = dmsString.replace(/(,)/, '.');
        match = dmsString.match(/[\d\.]+/ig);

        if (!_.isEmpty(match)) {
            d = match[0];
            m = match[1] || 0;
            s = match[2] || 0;

            if (d) {
                deg = GIS.Geometry.dmsToDeg(d * (sw ? -1 : 1), m, s);
            }
        }

        return deg;
    },
    /**
     * @param {number} deg Decimal degrees
     * @returns {number[]} Returns array [degrees, minutes, seconds]
     */
    degToDms(deg) {
        var d, m, s, frac;
        d = parseInt(deg, 10);
        frac = Math.abs(deg - d);
        m = Math.floor(frac * 60);
        s = Number((frac * 3600 - m * 60).toFixed(2));
        return [d, m, s];
    }
});
